import { Box, CircularProgress } from '@mui/material';

export function LoadingOverlay() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginY: 8,
      }}
    >
      <CircularProgress size="64px" />
    </Box>
  );
}
